import React from 'react'

function Footer() {
  return (
    <div className='Footer'
    style={{
        height: '100px',
        width: '100%',
        backgroundColor: '#1a1a1a',
        color: '#fff',
        textAlign: 'center',
        paddingTop: '20px',

    }}
    >
        <p>Copyright 2022 © Cool Bastrads. All rights reserved. <br/>
            Made by LazyDevs
        </p>
        </div>
  )
}

export default Footer